import { Button, Input, notification } from "antd";
import React from "react";
import api from "../../../../../../services/api";
import { isSuperUser } from "../../../../../../utils/is-superuser";

export function NovoNumeroContratoField({ acordoId, novoNumeroContrato }) {
  const [isEditing, setEditing] = React.useState(false);
  const [isSaving, setSaving] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(novoNumeroContrato);

  const toggleEdit = () => setEditing(!isEditing);

  const handleSave = () => {
    // save new value
    setSaving(true);

    api
      .put("/acordo/update-novo-numero-contrato/", {
        acordo_id: acordoId,
        novo_numero_contrato: inputValue
      })
      .then(() => {
        setEditing(false);
        setSaving(false);
        notification.success({
          message: "Novo número de contrato atualizado com sucesso."
        });
      })
      .catch(() => {
        setSaving(false);
        notification.error({
          message: "Falha ao salvar novo número de contrato"
        });
      });
  };

  const handleInputChange = event => setInputValue(event.target.value);
  const isAdmin = isSuperUser();

  return (
    <div
      style={{
        display: "flex",
        gap: "5px"
      }}
    >
      <Input
        disabled={!isEditing}
        placeholder="Vazio"
        onChange={handleInputChange}
        value={inputValue}
      />
      {isAdmin && (
        <React.Fragment>
          {isEditing ? (
            <Button
              type="primary"
              title="Salvar"
              onClick={handleSave}
              disabled={isSaving}
            >
              Salvar
            </Button>
          ) : (
            <Button
              icon="edit"
              type="primary"
              title="Editar"
              onClick={toggleEdit}
            />
          )}
        </React.Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoInfos/NovoNumeroContratoField/index.jsx